import { render, staticRenderFns } from "./SkeletonTable.vue?vue&type=template&id=1b41cc4f&"
var script = {}
import style0 from "./SkeletonTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports